import React from 'react';
// import './ThirdSection.css';
import { Container } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router';
import logo from '../../Raya logo/NewWaraqLogo__1_-removebg-preview.png';
import cover from '../../Raya logo/NewWaraqLogo__1_-removebg-preview.png'
const Waraq = () => {
    const navigate = useNavigate();

    const transferToPage = ()=>{
        // navigate('/Louco');
        window.open('https://waraq.co/')
    }

    return (
        <div className='main-first-section'>
            <Container maxWidth="xl">
                <div className='content newBrand'>
                    <div className='text-container'>
                        {/* <img src={logo} style={{width:'100%' , height:'100%' , marginLeft:'-10px'}}  alt='logo not found'/> */}
                        <h1>Bridging Languages and Cultures</h1>
                        <h3>Precision in every word. Confidence in every document.</h3>
                        <ArrowForwardIcon   onClick={transferToPage} style={{fontSize:'22px' , border:'1px solid #000' ,marginTop:'0px' ,  borderRadius:'50%' , padding:'4px' , cursor:'pointer'}}/>
                    </div>
                    <div className='louco-header-img'>
                        <img src={cover} alt="mobile image not found"/>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default Waraq;
